import React, {  useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Box, TextField, Button as MuiButton, Typography } from '@mui/material';
import { Table, Button as BootstrapButton, Form } from 'react-bootstrap';
import ENDPOINT from '../context/EndPoint';
import SecurityHeaders from '../context/SecurityHeaders';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch } from 'react-redux';
import { useActionsContext } from '../context/ActionsContext';
import { AuthContext } from '../context/AuthContext';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const FAQManager = () => {
    const dispatch = useDispatch();
  const [faqs, setFaqs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const {user} = useContext(AuthContext);
    const { rowsPerPage, setRowsPerPage } = useActionsContext(); 
  
  
  // Modal states
  const [openAdd, setOpenAdd] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  
  // Form data
  const [addForm, setAddForm] = useState({ page: '', category: '', title: '', description: '' });
  const [updateForm, setUpdateForm] = useState({ id: '', page: '', category: '', title: '', description: '' });
  const [deleteId, setDeleteId] = useState(null);

  // Fetch FAQs
  
    const fetchFaqs = async () => {
         dispatch({type:'LOADING'})
         const data = new FormData()
    data.append('session', user.SessionId)
    data.append('limit', rowsPerPage)
      try {
        setLoading(true);
        const response = await axios.post(`${ENDPOINT}get_faqs.php`, data, SecurityHeaders);
        if (response.data.status === 'success') {
      dispatch({type:'DONE_LOADING'})

          setFaqs(response.data.data);
        } else {
dispatch({type:'ERROR',payload:response.data.message})

      
        }
      } catch (err) {
dispatch({type:'ERROR',payload:'Failed to fetch FAQs'})


      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
    fetchFaqs();
  }, [rowsPerPage]);

  // Filter FAQs based on search term
  const filteredFaqs = faqs.filter(
    (faq) =>
      faq.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle add FAQ
  const handleAddSubmit = async (e) => {
    dispatch({type:'LOADING'})
    e.preventDefault();
    try {
      const response = await axios.post(`${ENDPOINT}create_faq.php`, addForm);
      if (response.data.status === 'success') {
        dispatch({type:'DONE_LOADING'})
        setFaqs([...faqs, { id: response.data.data.id, ...addForm }]);
        setAddForm({ page: '', category: '', title: '', description: '' });
        setOpenAdd(false);
      } else {
        setError(response.data.message);
        dispatch({type:'ERROR',payload:response.data.message})
      }
    } catch (err) {
      setError('Failed to create FAQ');
        dispatch({type:'ERROR',payload:'Failed to create FAQ'})
    }
  };

  // Handle update FAQ
  const handleUpdateSubmit = async (e) => {
    dispatch({type:'LOADING'})
    e.preventDefault();
    try {
      const response = await axios.put(`${ENDPOINT}update_faq.php`, updateForm);
      if (response.data.status === 'success') {
        dispatch({type:'DONE_LOADING'})
        setFaqs(faqs.map((faq) => (faq.id === updateForm.id ? { ...updateForm } : faq)));
        setUpdateForm({ id: '', page: '', category: '', title: '', description: '' });
        setOpenUpdate(false);
      } else {
        dispatch({type:'ERROR',payload:response.data.message})
        setError(response.data.message);
      }
    } catch (err) {
        dispatch({type:'ERROR',payload:'Failed to update FAQ'})
      setError('Failed to update FAQ');
    }
  };

  // Handle delete FAQ
  const handleDeleteSubmit = async () => {
    dispatch({type:'LOADING'})
    try {
      const response = await axios.delete(`${ENDPOINT}delete_faq.php`, {
        data: { id: deleteId },
      });
      if (response.data.status === 'success') {
        dispatch({type:'DONE_LOADING'})
        setFaqs(faqs.filter((faq) => faq.id !== deleteId));
        setOpenDelete(false);
        setDeleteId(null);
      } else {
        dispatch({type:'ERROR',payload:response.data.message})
        setError(response.data.message);
      }
    } catch (err) {
        dispatch({type:'ERROR',payload:'Failed to delete FAQ'})
      setError('Failed to delete FAQ');
    }
  };

  // Open update modal with FAQ data
  const openUpdateModal = (faq) => {
    setUpdateForm(faq);
    setOpenUpdate(true);
  };

  // Open delete modal
  const openDeleteModal = (id) => {
    setDeleteId(id);
    setOpenDelete(true);
  };

  if (loading) {
    return <div>Loading FAQs...</div>;
  }

  if (error) {
    return <div className="text-danger">Error: {error}</div>;
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-3">FAQ Manager</h2>
      <p className="text-muted mb-4">Manage frequently asked questions</p>

      {/* Search Bar */}
      <Form.Group className="mb-4">
        <Form.Control
          type="text"
          placeholder="Search by title or description..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Form.Group>

      {/* Add FAQ Button */}
      <BootstrapButton variant="primary" className="mb-4" onClick={() => setOpenAdd(true)}>
        Add FAQ
      </BootstrapButton>

      {/* FAQs Table */}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Page</th>
            <th>Category</th>
            <th>Title</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredFaqs.map((faq) => (
            <tr key={faq.id}>
              <td>{faq.id}</td>
              <td>{faq.page}</td>
              <td>{faq.category}</td>
              <td>{faq.title}</td>
              <td>{faq.description}</td>
              <td>
             
           <div className="d-flex justify-content-between my-auto">
                 <EditIcon     className="me-2 text-primary"
                  onClick={() => openUpdateModal(faq)}  type="button"/>
                 
                <DeleteIcon
                  className=" text-danger"
                    onClick={() => openDeleteModal(faq.id)}
                     type="button"
                />
           </div>
              
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Add FAQ Modal */}
      <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h2" mb={3}>
            Add FAQ
          </Typography>
          <form onSubmit={handleAddSubmit}>
            <TextField
              fullWidth
              label="Page"
              value={addForm.page}
              onChange={(e) => setAddForm({ ...addForm, page: e.target.value })}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Category"
              value={addForm.category}
              onChange={(e) => setAddForm({ ...addForm, category: e.target.value })}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Title"
              value={addForm.title}
              onChange={(e) => setAddForm({ ...addForm, title: e.target.value })}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Description"
              value={addForm.description}
              onChange={(e) => setAddForm({ ...addForm, description: e.target.value })}
              margin="normal"
              multiline
              rows={4}
              required
            />
            <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
              <MuiButton onClick={() => setOpenAdd(false)}>Cancel</MuiButton>
              <MuiButton type="submit" variant="contained" color="primary">
                Add
              </MuiButton>
            </Box>
          </form>
        </Box>
      </Modal>

      {/* Update FAQ Modal */}
      <Modal open={openUpdate} onClose={() => setOpenUpdate(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h2" mb={3}>
            Update FAQ
          </Typography>
          <form onSubmit={handleUpdateSubmit}>
            <TextField
              fullWidth
              label="ID"
              value={updateForm.id}
              disabled
              margin="normal"
            />
            <TextField
              fullWidth
              label="Page"
              value={updateForm.page}
              onChange={(e) => setUpdateForm({ ...updateForm, page: e.target.value })}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Category"
              value={updateForm.category}
              onChange={(e) => setUpdateForm({ ...updateForm, category: e.target.value })}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Title"
              value={updateForm.title}
              onChange={(e) => setUpdateForm({ ...updateForm, title: e.target.value })}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Description"
              value={updateForm.description}
              onChange={(e) => setUpdateForm({ ...updateForm, description: e.target.value })}
              margin="normal"
              multiline
              rows={4}
              required
            />
            <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
              <MuiButton onClick={() => setOpenUpdate(false)}>Cancel</MuiButton>
              <MuiButton type="submit" variant="contained" color="primary">
                Update
              </MuiButton>
            </Box>
          </form>
        </Box>
      </Modal>

      {/* Delete FAQ Modal */}
      <Modal open={openDelete} onClose={() => setOpenDelete(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h2" mb={3}>
            Confirm Delete
          </Typography>
          <Typography mb={3}>
            Are you sure you want to delete FAQ ID {deleteId}?
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <MuiButton onClick={() => setOpenDelete(false)}>Cancel</MuiButton>
            <MuiButton variant="contained" color="error" onClick={handleDeleteSubmit}>
              Delete
            </MuiButton>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default FAQManager;